var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeramic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_70)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.85749 24.787H24.1425C26.592 24.787 27.8225 23.5685 27.8225 21.1545V6.84502C27.8225 4.43102 26.592 3.21252 24.1425 3.21252H3.85749C1.41999 3.21302 0.17749 4.42002 0.17749 6.84502V21.155C0.17749 23.5805 1.41999 24.787 3.85749 24.787ZM2.06449 6.94002C2.06449 5.72102 2.72049 5.10002 3.89249 5.10002H9.06049V9.92852H2.06449V6.94002ZM10.83 9.92852V5.10002H17.123V9.92852H10.83ZM18.8925 9.92852V5.10002H24.1075C25.2675 5.10002 25.9355 5.72102 25.9355 6.94002V9.92852H18.8925ZM10.9125 16.42V11.58H17.205V16.42H10.9125ZM18.8925 16.42V11.58H25.9355V16.42H18.8925ZM9.06049 11.58V16.42H2.06449V11.58H9.06049ZM24.1075 22.9H18.8925V18.0725H25.9355V21.0605C25.9355 22.2795 25.2675 22.9 24.1075 22.9ZM3.89249 22.9005C2.72049 22.9005 2.06449 22.28 2.06449 21.061V18.0725H9.05999V22.901L3.89249 22.9005ZM10.83 18.073H17.123V22.9H10.83V18.073Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_70"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeramic);
export default __webpack_public_path__ + "static/media/seramic.49e507f69901c18a466d49478ac86ab2.svg";
export { ForwardRef as ReactComponent };